import {GET_TICKER} from '../types';
import axios from 'axios';
import {domain, naturalUrlAttr} from "../../config";

export const getTicker = () => async dispatch => {

    try {
        const response = await axios.get(`${domain}ticker?${naturalUrlAttr}`);

        dispatch({
            type: GET_TICKER,
            payload: response.data
        });
    } catch (e) {
        console.log('Error ticker');
    }

};
